<template>
  <div class="innerBox">

    <h2 class="mb-4">Complain</h2>
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox" style="padding:0">
        <div class="col row">
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
          </div>
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Tanggal</label>
            <flat-pickr
              v-model="selected.date"
              :config="rangeConfig"
              placeholder="Pilih Tanggal"
            ></flat-pickr>
          </div>
          <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    
    <vue-universal-table
      api_url="/api/v1/workorder/complaints"
      :fields="vue_universal_table.fields"
      :special_buttons="vue_universal_table.specialButtons"
      :filter="filter"
      :update="vue_universal_table.update"
      @onComplainBaru="modal.newComplain = true"
    ></vue-universal-table>

    <!-- Modal Start -->
    <new-complain-work-order
      v-if="modal.newComplain"
      @closeModal="modal.newComplain = false"
    ></new-complain-work-order>
    <!-- Modal End -->

  </div>
</template>

<script>
  import moment from 'moment'

  import newComplainWorkOrder from './children/newComplainWorkOrder'

  export default {
    data () {
      const start = moment().startOf('month').format('YYYY-MM-DD');
      let end  = new moment().format('YYYY-MM-DD')

      return {
        modal : {
          newComplain : false
        },
        data : null,
        filter: {
          start: start,
          end: end,
          search : ''
        },
        mobile : this.isMobile(),
        selected : {
          date : `${start} to ${end}`,
        },
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input w-100',
          animate: !this.isRTL()
        },
        showNewUserModal : false,
        apiLoading: true,
        vue_universal_table : {
          update : 0,
          specialButtons:['ComplainBaru'],
          fields : [
            {
              title : 'Form Code',
              variable : 'form_code'
            },
            {
              title : 'Nama Pelanggan',
              variable : 'nama_pelanggan'
            },
            {
              title : 'Nomor Polisi',
              variable : 'no_polisi'
            },
            {
              title : 'Waktu Pembuatan',
              variable : 'waktu_pembuatan'
            }
          ],
        }
      }
    },
    components : {
      newComplainWorkOrder,
    },
    mounted () {
    },
    methods : {
      complainWorkOrder (x) {
        this.$router.push({name : 'ComplainView', params: {id : x.replace(/"/g, "")}})
      }
    },
    watch : {
      'selected.date'(){
        var date = this.selected.date.split(" to ");
        this.filter.start = date[0]
        this.filter.end = date[1] ? date[1] : date[0]
      }
    }
  }
</script>

<style scoped>
  
</style>